module.exports = __webpack_public_path__ + "static/media/ActionThrillers_movies.d748d860.png";